module.exports = __webpack_public_path__ + "media/images/bubble-img-02-c0c96f37c4e653d7830080ad857d7623.svg";